export const toSeatClass = ({ seatClass }) => seatClass
